// src/components/LanguageInfoPanel/LanguageInfoPanel.jsx
import React, { useState, useEffect, forwardRef } from "react";
import FromToLanguage from "../FromToLanguage/FromToLanguage";
import TranslationStats from "../TranslationStats/TranslationStats";
import { getStoredLanguages } from "../../utils/LocalStorageUtils";
import "./LanguageInfoPanel.css";

const LanguageInfoPanel = forwardRef(
  (
    {
      statsTextStorageKey,
      disableHide,
      translationStatsOnly,
      onLanguageSelectionChanged,
      fromStorageKey,
      toStorageKey,
      selectionRequired,
    },
    ref
  ) => {
    const [fromLanguage, setFromLanguage] = useState(null);
    const [toLanguage, setToLanguage] = useState(null);

    useEffect(() => {
      try {
        const { storedFromSelected, storedToSelected } = getStoredLanguages(
          fromStorageKey,
          toStorageKey
        );

        // Set fromLanguage if valid
        if (
          storedFromSelected &&
          storedFromSelected.id &&
          storedFromSelected.name
        ) {
          setFromLanguage(storedFromSelected);
          onLanguageSelectionChanged({
            ...storedFromSelected,
            type: "from",
          });
        }

        // Set toLanguage if valid
        if (storedToSelected && storedToSelected.id && storedToSelected.name) {
          setToLanguage(storedToSelected); // Fixed: Changed storedToLanguage to storedToSelected
          onLanguageSelectionChanged({
            ...storedToSelected,
            type: "to",
          });
        }
      } catch (err) {
        console.error("Error loading stored languages:", err);
      }
    }, [fromStorageKey, toStorageKey, onLanguageSelectionChanged]);

    const handleLanguageSelectionChanged = ({
      id,
      name,
      number_of_speakers,
      location,
      code,
      flag,
      type,
    }) => {
      console.log(`${type} Language Selected:`, {
        id,
        name,
        number_of_speakers,
        location,
        code,
        flag,
      });
      const updatedLanguage = {
        id,
        name,
        number_of_speakers,
        location,
        code,
        flag,
      };

      if (type === "from") {
        setFromLanguage(updatedLanguage);
      } else {
        setToLanguage(updatedLanguage);
      }

      onLanguageSelectionChanged({
        id,
        name,
        number_of_speakers,
        location,
        code,
        flag,
        type,
      });
    };

    return (
      <div className="language-info-panel">
        {!translationStatsOnly && (
          <div className="language-selection-section mb-4">
            <FromToLanguage
              ref={ref}
              onLanguageSelectionChanged={handleLanguageSelectionChanged}
              fromStorageKey={fromStorageKey}
              toStorageKey={toStorageKey}
              selectionRequired={selectionRequired}
            />
          </div>
        )}
        <div className="translation-stats-section">
          <TranslationStats
            fromLanguage={fromLanguage}
            toLanguage={toLanguage}
            localStorageKey={statsTextStorageKey}
            disableHide={disableHide}
          />
        </div>
      </div>
    );
  }
);

export default LanguageInfoPanel;
